import { Directive, Input , ElementRef, Renderer2, OnInit} from '@angular/core';

@Directive({
  selector: '[appStatus]'
})
export class StatusDirective implements OnInit{
    
  @Input() value: string;
  
  constructor(private elRef: ElementRef, private render: Renderer2){

  }
 
  ngOnInit(){

      if(this.value == "Online"){
 
        const text = this.render.createText('Online');
       
        this.render.appendChild(this.elRef.nativeElement, text);
        this.render.addClass(this.elRef.nativeElement, "badge");
        this.render.addClass(this.elRef.nativeElement, "badge-success");
  
      }else  if(this.value == "Offline"){
 
        const text = this.render.createText('Offline');
       
        this.render.appendChild(this.elRef.nativeElement, text);
        this.render.addClass(this.elRef.nativeElement, "badge");
        this.render.addClass(this.elRef.nativeElement, "badge-danger");
  
      }else{

        const text = this.render.createText('Testando...');
        
        this.render.appendChild(this.elRef.nativeElement, text);
        this.render.addClass(this.elRef.nativeElement, "badge");
        this.render.addClass(this.elRef.nativeElement, "badge-secondary");
  
      }

    }
    

}

